import { useState, useContext } from "react";
import { supabase } from "../supabaseClient";
import { ThemeContext } from "../ThemeContext";
import logo from "../assets/logo.png";

export default function Login({ onLogin }) {
  const theme = useContext(ThemeContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    setLoading(true);
    setError("");
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) setError(error.message);
    else onLogin(data.user);
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", background: theme.background }}>
      <div style={{ backgroundColor: theme.cardBackground, padding: 30, borderRadius: 10, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", width: 320 }}>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <img src={logo} alt="Logo" style={{ width: 100, display: "block", margin: "0 auto" }} />
        </div>
        <h2 style={{ textAlign: "center", marginBottom: 20, color: theme.text }}>Login</h2>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ width: "100%", padding: 10, marginBottom: 15, borderRadius: 5, border: `1px solid ${theme.text}` }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: "100%", padding: 10, marginBottom: 20, borderRadius: 5, border: `1px solid ${theme.text}` }}
        />

        <button
          onClick={handleLogin}
          disabled={loading}
          style={{ width: "100%", padding: 10, borderRadius: 5, border: "none", backgroundColor: theme.primary, color: theme.buttonText, cursor: "pointer" }}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        {error && <p style={{ color: "red", marginTop: 15, textAlign: "center" }}>{error}</p>}
      </div>
    </div>
  );
}
